import { t } from 'i18next';
import * as yup from 'yup';

import { testRequiredSchema } from 'core/schemas';

export const upsertTaxonomyGroupSchema = (taxonomyRequired = false, taxonomyLevel?: number) =>
  yup.object().shape(upsertTaxonomyGroupSchemaFields(taxonomyRequired, taxonomyLevel));

export const upsertTaxonomyGroupSchemaFields = (
  taxonomyRequired: boolean,
  taxonomyLevel?: number
) => ({
  taxonomy: yup
    .object()
    .label(t('labelCategory'))
    .nullable()
    .test(...testRequiredSchema(taxonomyRequired, t('labelCategory')))
    .test(
      'level-check',
      t('errorTaxonomyLevelBellowMinimum', { minimum: taxonomyLevel }),
      function (value) {
        if (!taxonomyLevel || !value) {
          return true;
        }

        if (value && value.level !== undefined) {
          return value.level >= taxonomyLevel;
        }

        return false;
      }
    ),
});
